// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

.mat-mdc-dialog-content {
  height: 100%;
}

mat-form-field {
  width: 100%;
}

.mat-mdc-dialog-actions[align=end] {
  justify-content: flex-end;
}

.bt-spinner {
  display: inline;
  padding-right: 30px;
}

.first-field {
  margin-top: 15px;
}

.fixActionRow {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex-grow: 1;
}

.admos-title {
  font-weight: bolder;
  margin-bottom: 15px;
}

.admo-item {
  position: relative;
  margin-bottom: 20px;
  border-bottom: 1px solid lightgray;
  padding-bottom: 15px;
}
.admo-item .row {
  padding-bottom: 10px;
}
.admo-item .grid {
  height: 100%;
  min-height: 100%;
  min-width: 100%;
  width: 100%;
}
.admo-item .checkbox-col {
  padding: 0px 15px 15px 0px !important;
}
.admo-item .blue-text {
  color: #0175c0;
  font-weight: bolder;
}
.admo-item ::ng-deep .mat-expansion-panel .separator-line {
  display: block;
  border-bottom: 1px solid lightgray;
  width: fit-content;
  padding: 6px 0;
}
.admo-item ::ng-deep .mat-expansion-panel .separator-line:last-child {
  border-bottom: none;
}
.admo-item .new-tab {
  position: absolute;
  top: 0px;
  right: 0px;
  color: #0175c0;
  font-size: large;
  cursor: pointer;
}
.admo-item .mat-accordion {
  margin-top: 10px;
  display: block;
}
.admo-item .mat-accordion .mat-expansion-panel {
  box-shadow: none !important;
  background: #f6f6f6;
}

.strong {
  font-weight: bolder;
}

.first-field {
  margin-top: 15px;
}

.admos-radio-group::ng-deep {
  display: block;
  width: 100%;
}
.admos-radio-group::ng-deep .mat-mdc-radio-button {
  width: 100%;
}
.admos-radio-group::ng-deep .mat-mdc-radio-button .mat-radio-label {
  align-items: flex-start;
  width: 100%;
}
.admos-radio-group::ng-deep .mat-mdc-radio-button .mat-radio-label .mat-radio-label-content {
  width: calc(100% - 30px);
}

.select-button {
  line-height: 14px;
  white-space: normal;
  padding: 5px;
  font-weight: normal;
  background-color: #0175c0;
  color: white;
}
.select-button.selected {
  background-color: #32c5d2;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/modules/admin/admonitorings/components/search-admo/search-admo.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAdA;EACI,YAAA;AAiBJ;;AAdA;EACI,WAAA;AAiBJ;;AAdA;EACI,yBAAA;AAiBJ;;AAdA;EACI,eAAA;EACA,mBAAA;AAiBJ;;AAdA;EACI,gBAAA;AAiBJ;;AAdA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AAiBJ;;AAdA;EACI,YAAA;AAiBJ;;AAdA;EACI,mBAAA;EAEA,mBAAA;AAgBJ;;AAbA;EACI,kBAAA;EACA,mBAAA;EACA,kCAAA;EACA,oBAAA;AAgBJ;AAdI;EACI,oBAAA;AAgBR;AAbI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAeR;AAZI;EACI,qCAAA;AAcR;AAXI;EACI,cDoCW;ECnCX,mBAAA;AAaR;AATQ;EACI,cAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;AAWZ;AAVY;EACI,mBAAA;AAYhB;AAPI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cDgBW;ECfX,gBAAA;EACA,eAAA;AASR;AANI;EACI,gBAAA;EACA,cAAA;AAQR;AAPQ;EACI,2BAAA;EACA,mBAAA;AASZ;;AAJA;EACI,mBAAA;AAOJ;;AAJA;EACI,gBAAA;AAOJ;;AAJA;EACI,cAAA;EACA,WAAA;AAOJ;AANI;EACI,WAAA;AAQR;AAPQ;EACI,uBAAA;EACA,WAAA;AASZ;AARY;EACI,wBAAA;AAUhB;;AAJA;EACI,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBD3Be;EC4Bf,YAAA;AAOJ;AANI;EACI,yBAAA;AAQR","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@use '@angular/material' as mat;\n@import \"./../../../../../../theme/theme.scss\";\n\n.mat-mdc-dialog-content {\n    height: 100%;\n}\n\nmat-form-field {\n    width:100%;\n}\n\n.mat-mdc-dialog-actions[align=end] {\n    justify-content: flex-end;\n}\n\n.bt-spinner {\n    display: inline;\n    padding-right: 30px;\n}\n\n.first-field {\n    margin-top: 15px;\n}\n\n.fixActionRow {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.spacer {\n    flex-grow: 1;\n}\n\n.admos-title {\n    font-weight: bolder;\n    // color: $comv-middle-blue;\n    margin-bottom: 15px;\n}\n\n.admo-item {\n    position: relative;\n    margin-bottom: 20px;\n    border-bottom: 1px solid lightgray;\n    padding-bottom: 15px;\n\n    .row {\n        padding-bottom: 10px;\n    }\n\n    .grid {\n        height: 100%;\n        min-height: 100%;\n        min-width: 100%;\n        width: 100%;\n    }\n\n    .checkbox-col {\n        padding: 0px 15px 15px 0px!important;\n    }\n\n    .blue-text {\n        color: $comv-middle-blue;\n        font-weight: bolder;\n    }\n\n    ::ng-deep .mat-expansion-panel {\n        .separator-line {\n            display: block;\n            border-bottom: 1px solid lightgray;\n            width: fit-content;\n            padding: 6px 0;\n            &:last-child {\n                border-bottom: none;\n            }\n        }\n    }\n\n    .new-tab {\n        position: absolute;\n        top: 0px;\n        right: 0px;\n        color: $comv-middle-blue;\n        font-size: large;\n        cursor: pointer;\n    }\n\n    .mat-accordion {\n        margin-top: 10px;\n        display: block;\n        .mat-expansion-panel {\n            box-shadow: none!important;\n            background: #f6f6f6;\n        }\n    }\n}\n\n.strong {\n    font-weight: bolder;\n}\n\n.first-field {\n    margin-top: 15px;\n}\n\n.admos-radio-group::ng-deep {\n    display: block;\n    width: 100%;\n    .mat-mdc-radio-button {\n        width: 100%;\n        .mat-radio-label {\n            align-items: flex-start;\n            width: 100%;\n            .mat-radio-label-content {\n                width: calc(100% - 30px);\n            }\n        }\n    }\n}\n\n.select-button {\n    line-height: 14px;\n    white-space: normal;\n    padding: 5px;\n    font-weight: normal;\n    background-color: $comv-middle-blue;\n    color: white;\n    &.selected {\n        background-color: mat.m2-get-color-from-palette($my-app-primary);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
